'use client'

import { FC } from 'react'

import { Button, ModalBase } from '@/components/commons'
import { AttentionRoundIcon, CheckRoundIcon } from '@/components/icons'

import { ModalCaseType, ModalInformationProps } from './types'

const ModalInformation: FC<ModalInformationProps> = ({
  isOpenModal,
  setIsOpenModal,
  variant,
  customMessage,
  handleGoToLogin,
  ...props
}) => {
  const modalCase: ModalCaseType = {
    customMessage: {
      icon: (
        <AttentionRoundIcon className="fill-status-red w-[80px] h-[80px]" />
      ),
      title: (
        <h5 className="prose-headline-h5 text-status-fill-status-red">
          Atenção
        </h5>
      ),
      paragraph: (
        <span className="flex w-full flex-col gap-4 items-start">
          {customMessage?.length && Array.isArray(customMessage) ? (
            customMessage?.map((item, index) => (
              <p
                key={`custom-message-form-create-profile-${index}`}
                className="prose-body"
              >
                {item?.message as string}
              </p>
            ))
          ) : customMessage?.length ? (
            <p className="prose-body">{customMessage as string}</p>
          ) : null}
        </span>
      ),
      buttons: (
        <Button
          className="w-[158px]"
          text="Voltar"
          onClick={(event) => {
            event.preventDefault()
            setIsOpenModal(false)
          }}
        />
      ),
    },
    resetPasswordSuccess: {
      icon: <CheckRoundIcon className="fill-status-green w-[80px] h-[80px]" />,
      title: (
        <h5 className="prose-headline-h5 text-status-fill-status-red">
          Sucesso!
        </h5>
      ),
      paragraph: (
        <span className="flex w-full flex-col gap-4 items-start">
          <p className="prose-body">Senha alterada!</p>
          <p className="prose-body">
            Vá para a página de login e acesse a aplicação.
          </p>
        </span>
      ),
      buttons: (
        <Button
          className="w-[158px]"
          text="Ir para Login"
          type="button"
          onClick={handleGoToLogin}
        />
      ),
    },
  }

  return (
    <ModalBase
      className="w-full max-w-[464px]"
      isOpenModal={isOpenModal}
      {...props}
    >
      <ModalBase.Header>
        {modalCase[variant].icon}
        {modalCase[variant].title}
        {modalCase[variant].paragraph}
      </ModalBase.Header>
      <ModalBase.Footer className="justify-end">
        {modalCase[variant].buttons}
      </ModalBase.Footer>
    </ModalBase>
  )
}

export default ModalInformation
